import React from "react";
import { HexColorPicker } from "react-colorful";

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  onChange,
}) => {
  return (
    <>
      <div className="relative w-full">
        <HexColorPicker color={value} onChange={onChange} />
      </div>
      <style>
        {`
        .react-colorful {
          width: 100%;
          aspect-ratio: 1 / 1;
          height: 100%;
        }

        .react-colorful__saturation {
          border-radius: 0px;
          margin-bottom: 0px;
          border: 0;
          // border-radius: 0.75rem 0.75rem 0 0;
        }

        .react-colorful__saturation-pointer {
          width: 16px;
          height: 16px;
          border-radius: 8px;
        }

        .react-colorful__hue-pointer,
        .react-colorful__alpha-pointer {
          width: 16px;
          height: 16px;
          border-radius: 36px;
        }    

        .react-colorful__hue,
        .custom-pointers .react-colorful__alpha {
          height: 8px;
          border-radius: 0px;
        }

        .react-colorful__hue {
        margin:12px 8px;
        border-radius: 4px;
        }
        `}
      </style>
    </>
  );
};
